import { Paragraph } from './FormInputText.styles';
import { FormGroup, Label } from './styles/common';

export function FormInputSelect({
  label,
  placeholder,
  options,
  registration,
  error,
  valid,
  disabled,
  value,
  onChange,
  paragraph,
  formGroupClassName,
  customStyle = '',
  // Optional note under the field. Marks a value filled in from an uploaded document,
  // so the user knows to check it rather than assume we got it right.
  // See FormInputText: marks a value that came from an uploaded document.
  hint,
}) {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  if (registration === undefined) {
    return (
      <FormGroup className={formGroupClassName}>
        {label && <Label>{label}</Label>}
        {paragraph !== undefined && <Paragraph>{paragraph}</Paragraph>}
        <select
          className={`form-control text-center fw-bold ${error ? 'is-invalid' : ''
          } ${valid ? 'is-valid' : ''} ${customStyle}`}
          disabled={disabled ?? false}
          onChange={handleChange}
          value={value}
        >
          <option value="" disabled className="fw-normal">
            {placeholder}
          </option>
          {options.map((opt, index) => (
            <option
              key={index}
              value={opt.id ? opt.id : opt}
            >
              {opt.id ? opt.name : opt}
            </option>
          ))}
        </select>
        <div className="invalid-feedback">{error}</div>
        {hint && <p className="form-input-hint">{hint}</p>}
      </FormGroup>
    );
  }

  return (
    <FormGroup className={formGroupClassName}>
      {label && <Label>{label}</Label>}
      {paragraph !== undefined && <Paragraph>{paragraph}</Paragraph>}

      <select
        className={`form-control text-center fw-bold ${error ? 'is-invalid' : ''
        } ${valid ? 'is-valid' : ''} ${customStyle}`}
        disabled={disabled ?? false}
        {...registration}
        value={value}
      >
        <option value="" disabled className="fw-normal">
          {placeholder}
        </option>
        {options.map((opt, index) => (
          <option
            key={index}
            value={opt.id ? opt.id : opt}
          >
            {opt.id ? opt.name : opt}
          </option>
        ))}
      </select>
      <div className="invalid-feedback">{error}</div>
      {hint && <p className="form-input-hint">{hint}</p>}
    </FormGroup>
  );
}
